import dev from './development/en.json';
const merge = require('deepmerge');

export default async ({ $axios, $config }) => {
    return await $axios
        .$get(`${$config.tolgeeURL}/v2/projects/translations/en?ak=${$config.tolgeeApiKey}`)
        .then((res) => {
            return merge(dev, res.en);
        });
};
